// extracted by mini-css-extract-plugin
module.exports = {"filter":"_59108b6","label":"_8435214"};